import { render, staticRenderFns } from "./EditKeyTPK.vue?vue&type=template&id=6735fdc0"
import script from "./EditKeyTPK.vue?vue&type=script&lang=js"
export * from "./EditKeyTPK.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports